export default __webpack_public_path__ + "static/icons/elevation-forecast-img-bot-351d8159ffe11772ad1361ac8fc8ac08.svg";